module.exports = __webpack_public_path__ + "media/images/checked-dafe170e87eb78eebf5f423d43d1a2f3.png";